import React from 'react';
import { Button } from 'reactstrap';

//Componentes auxiliares:
import CustomCard from './auxiliars/CustomCard';

//Scripts y constantes auxiliares:
import { rolesList, getCanDoBasedOnPermissions } from './scripts/rolesDescription';
import UserOptionsDropdown from './auxiliars/UserOptionsDropdown';

let OwnProfileManager = (props) => {
    return (
        <CustomCard title="Mi perfil" style={{ marginBottom: 5 }} cardStyle={{ paddingBottom: 20 }}>
            <div style={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}
                data-tut="reactour__usersManagement.ownProfileManager">
                <div style={{ flex: "25%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <div style={{ flex: "75%" }}>
                        <Button className="btn-round btn-icon" size="md" color="success" style={{ marginTop: 0 }}>
                            {getRoleIconComponent(props)}
                        </Button>
                    </div>

                    <div style={{ flex: "25%" }}>
                        <p style={{ fontSize: 10, marginBottom: 0, textTransform: "uppercase", fontWeight: "bold" }}>
                            <b>{getRoleName(props)}</b>
                        </p>
                    </div>
                </div>

                <div style={{ flex: "60%", height: "100%", display: "flex", justifyContent: "center", flexDirection:"column"  }}>
                    <div style={{ flex: "35%" }}>
                        <p style={{ fontSize: 10, marginBottom: 0, textTransform: "uppercase", fontWeight: "bold" }}>
                            <b>{props.activeUser.email}</b>
                        </p>
                    </div>

                    <div style={{ flex: "75%" }}>
                        <p className="text-muted" style={{ marginTop: 5, marginBottom: 0, overflowY: "hidden" }}>
                            <small>
                                {getCanDoBasedOnPermissions(props.activeUser, "Puedo")}
                            </small>
                        </p>
                    </div>
                </div>

                <div style={{ flex: "15%", height: "100%", display: "flex", justifyContent: "center" }}
                    data-tut="reactour__usersManagement.ownProfileManagerOptions">
                    <UserOptionsDropdown />
                </div>
            </div>
        </CustomCard >
    );
}

let getRoleIconComponent = (props) => {
    if (props.activeUser.is_admin) { return (rolesList[0].iconComponent); }
    if (props.activeUser.is_staff) { return (rolesList[1].iconComponent); }

    return (rolesList[2].iconComponent);
}

let getRoleName = (props) => {
    if (props.activeUser.is_admin) { return "Admin"; }
    if (props.activeUser.is_staff) { return "Staff"; }

    return "Lector";
}

export default OwnProfileManager;